export default __webpack_public_path__ + "static/media/banner3.4ceb56f4.png";